export function resolveSeasonChangePath(
  pathname: string,
  leagueId: string,
  seasonId: string | null,
): string {
  if (!seasonId) {
    return pathname;
  }

  if (/^\/leagues\/[^/]+\/admin\/seasons\/[^/]+\/players$/.test(pathname)) {
    return `/leagues/${leagueId}/admin/seasons/${seasonId}/players`;
  }

  return pathname;
}
